import { render, staticRenderFns } from "./coins.vue?vue&type=template&id=8871092e&"
import script from "./coins.vue?vue&type=script&lang=js&"
export * from "./coins.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports